import styles from "./PermToggle.module.css";

export default function PermToggle({ checked, onChange, label, description }) {
    return (
        <label className={styles.row}>
            <div className={styles.text}>
                <div className={styles.label}>{label}</div>
                {description ? <div className={styles.desc}>{description}</div> : null}
            </div>

            <span className={styles.switch}>
                <input
                    type="checkbox"
                    checked={!!checked}
                    onChange={(e) => onChange(e.target.checked)}
                />
                <span className={styles.slider} />
            </span>
        </label>
    );
}